export default {"src":"/_next/static/media/iMessage.b552a388.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};